// @flow
import * as React from 'react';
import classnames from 'classnames';
import Box from 'sail/Box';
import {useVideos} from 'docs/data';
import type {Article} from 'docs/data';
import {useActivePage} from 'docs/hooks';
import './RightPane.scss';
import {VideoPlayerPlaceholder} from 'docs/shell/videos/VideoPlayerPlaceholder';
import {TableOfContents} from './TableOfContents';
import {RecommendedDocs} from './RecommendedDocs';

type RightPaneProps = {|
  article: Article,
  contentRef: React.ElementRef<any>,
|};

export const RightPane = ({article, contentRef}: RightPaneProps) => {
  const {tocVideo} = useVideos();
  const activePage = useActivePage();

  // Originally the entire right pane was called the toc so in frontmatter
  // to not show the right pane we set toc to false, this should really be called
  // rightPane
  const showRightPane = article.features.toc;
  const showToC = activePage.sections.length >= 2;
  const showRecDocs = !!article.recommendedDocs;

  // Don't want to show the right pane on pages like /docs which
  // don't explicitly define no right pane in frontmatter
  if (!showRightPane || (!showToC && !showRecDocs && !tocVideo)) {
    return null;
  }

  return (
    <Box className="RightPane">
      {tocVideo && (
        <Box className="RightPane-video">
          <VideoPlayerPlaceholder />
        </Box>
      )}
      <Box
        className={classnames(
          tocVideo
            ? 'RightPaneScrollable--has-video'
            : 'RightPaneScrollable--has-no-video',
        )}
      >
        {showToC && (
          <TableOfContents article={article} contentRef={contentRef} />
        )}
        {showRecDocs && <RecommendedDocs article={article} />}
      </Box>
    </Box>
  );
};
